(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maaree-dr-shipping"] && !Shopify.designMode) return;
  try {
    
  // Shared region-tab sync. Runs once per page; idempotent if multiple
  // sections include it. Clicking any .maaree-dr-tab updates aria-selected
  // on every other tab with the same data-region value, and toggles the
  // matching panels across all tabsets on the page.
  (function () {
    if (window.__maareeDrTabsBound) return;
    window.__maareeDrTabsBound = true;

    function activateRegion(region) {
      document.querySelectorAll('.maaree-dr-tab').forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.region === region ? 'true' : 'false');
      });
      document.querySelectorAll('.maaree-dr-panel').forEach(function (p) {
        var match = p.dataset.region === region;
        p.classList.toggle('is-active', match);
        if (match) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('.maaree-dr-tab');
      if (!tab) return;
      e.preventDefault();
      activateRegion(tab.dataset.region);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
